(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleDialogController', TradePolicyRuleDialogController);

    TradePolicyRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicyRule', 'TradePolicy'];

    function TradePolicyRuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicyRule, TradePolicy) {
        var vm = this;
        vm.tradePolicyRule = entity;
        vm.tradepolicies = TradePolicy.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicyRule.id !== null) {
                TradePolicyRule.update(vm.tradePolicyRule, onSaveSuccess, onSaveError);
            } else {
                TradePolicyRule.save(vm.tradePolicyRule, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
